import React, { type CSSProperties, useMemo } from 'react';

import { Box, darken, getLuminance, lighten, type SxProps } from '@mui/material';
import {
  useGlobalBodyBackgroundColor,
  useGlobalConfiguration,
} from '@wp-block-builder/stores/WaypointDocumentStore/useGlobalStyles';

type Props = {
  children: JSX.Element;
};
export default function FooterLine({ children }: Props) {
  const { canvasStyle } = useGlobalConfiguration();
  const { maxWidth, minHeight } = canvasStyle;
  const style = useMemo<CSSProperties>(
    () => ({
      maxWidth: maxWidth || '600px',
      minHeight: minHeight || '48px',
    }),
    [maxWidth, minHeight]
  );

  const globalBackgroundColor = useGlobalBodyBackgroundColor();
  const textColor = useMemo(() => {
    return getLuminance(globalBackgroundColor) > 0.5
      ? darken(globalBackgroundColor, 0.6)
      : lighten(globalBackgroundColor, 0.7);
  }, [globalBackgroundColor]);
  const baseStyle = useMemo<SxProps>(
    () => ({
      textAlign: 'center',
      fontSize: '12px',
      color: textColor,
      a: { color: textColor },
    }),
    [textColor]
  );

  return (
    <table align="center" width="100%" style={style} role="presentation" cellSpacing="0" cellPadding="0" border={0}>
      <tbody>
        <tr style={{ width: '100%' }}>
          <Box component="td" sx={baseStyle}>
            {children}
          </Box>
        </tr>
      </tbody>
    </table>
  );
}
